import { useRef } from 'react';
import { BsFillPersonCheckFill } from 'react-icons/bs';
import { useHistory } from 'react-router';
import {
  AttributesTable,
  AttributesTableRow,
  Button,
  Icon,
  Modal,
  ModalFooter,
} from '@nbirl/nbi-common-ui-libs';

import { PATHS } from '../../../shared/constants';
import { User } from '../models';
import { RoleLabel } from './role-label.component';
import { UserFolders } from './user-folders.component';

export const UserSaveSuccessModal = ({
  heading,
  user,
}: {
  heading: string;
  user: Pick<User, 'name' | 'email' | 'mobileNumber' | 'role' | 'folders'>;
}) => {
  const history = useHistory();
  const doneRef = useRef<HTMLButtonElement>(null);

  const handleSuccessModalDismiss = () => {
    history.push(PATHS.UserManagement);
  };

  return (
    <Modal
      headingIcon={<Icon icon={<BsFillPersonCheckFill />} />}
      variant="success"
      onDismiss={handleSuccessModalDismiss}
      heading={heading}
      isOpen={true}
      initialFocusRef={doneRef}
    >
      <AttributesTable>
        <AttributesTableRow label="Name">{user.name}</AttributesTableRow>
        <AttributesTableRow label="Email">{user.email}</AttributesTableRow>
        <AttributesTableRow label="Mobile">
          {user.mobileNumber}
        </AttributesTableRow>
        <AttributesTableRow label="Role">
          <RoleLabel role={user.role} />
        </AttributesTableRow>
        <AttributesTableRow label="Folders">
          <UserFolders role={user.role} folders={user.folders} />
        </AttributesTableRow>
      </AttributesTable>
      <hr className="border-t border-primary-100 mt-8 -mx-8" />
      <ModalFooter>
        <Button ref={doneRef} onClick={handleSuccessModalDismiss}>
          Done
        </Button>
      </ModalFooter>
    </Modal>
  );
};
